module.exports = __webpack_public_path__ + "static/media/uploadIcon.afd89d03.svg";